// src/components/games/crossroads/ShieldIndicator.tsx
// Visual indicator for damage prevention shields

import React from 'react';
import { IonBadge, IonIcon } from '@ionic/react';
import { shieldCheckmarkOutline } from 'ionicons/icons';
import './ShieldIndicator.css';

interface ShieldIndicatorProps {
  amount: number;
  compact?: boolean;
}

const ShieldIndicator: React.FC<ShieldIndicatorProps> = ({ amount, compact = false }) => {
  if (amount <= 0) return null;

  return (
    <IonBadge color="success" className={`shield-indicator ${compact ? 'compact' : ''}`}>
      <IonIcon icon={shieldCheckmarkOutline} />
      <span className="shield-amount">{amount}</span>
    </IonBadge>
  );
};

export default ShieldIndicator;
